import styled from "styled-components";
import MovieInfoLabel from "./MovieInfoLabel";

const MovieRating = styled(MovieInfoLabel)`
  background: var(--text-primary);
  color: var(--page-bg);
  font-size: 1.167em;
  font-weight: 700;

  body.theme-market & {
    background: var(--primary);
    color: #FFFFFF;
    font-weight: 700;
  }

  body.theme-platinum & {
    background: var(--primary);
    color: var(--text-primary);
    font-weight: 700;
  }
`;

export default MovieRating;